<script>
    import { onMount } from 'svelte';
    import { fetchMOUByHash, updateMOUByHash } from '/public/services/User.js';
    import { slide, fade } from 'svelte/transition';
    import dayjs from 'dayjs';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let m;
    let org;

    let auth = {
        auth_by_name: null,
        auth_by_email: null,
        auth_by_position: null,
        tc: null,
        authorised: null
    }

    function loadMOU() {
        fetchMOUByHash(hash).then(res => {
            if (res.success) {
                m = res.data.mou;
                org = res.data.organisation;

                loading = false;
            }
        });
    }

    function authSubmitForm(e) {
        e.preventDefault();

        if (auth.tc == null) {
            alert('You must accept the Terms and Conditions');
            return;
        }

        if (auth.authorised == null) {
            alert('You must authorise this contract');
            return;
        }

        updateMOUByHash(hash, auth).then(res => {
            if (res.success) {
                loading = true;

                loadMOU();
            }
        });
    }


    onMount(() => {
        loadMOU();
    });
</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Loading your Contract....
        </h4>
    </div>

{:else}

    <section in:slide>
        <div class='row justify-content-center'>
            <div class='col-sm-12 col-md-8'>

                <h3>
                    Agreement for Memorandum of Understanding
                </h3>
                <hr/>

                {#if m.authorised === true}

                    <div class='alert alert-success clearfix mb-3'>
                        <h4 class='float-start me-3'>
                            <span class='fas fa-check-circle'></span>
                        </h4>
                        Memorandum of Understanding agreement authorised by <b>{ m.auth_by_name }</b> - { m.auth_by_position } on {dayjs(m.auth_by_date_incept).format('dddd, MMMM YYYY')}.                        
                    </div>

                {/if}
                
                <h3>
                    Between
                </h3>

                <div class="row">
                    <div class="col-md-6">
                        <h4 class="text-center">
                            { org.title }<br/>
                            <small>
                                (Client)
                            </small>
                        </h4>
                    </div>
                    <div class="col-md-6">
                        <h4 class="text-center">
                            Workplace First Aid Training Limited<br/>
                            <small>
                                (Course Provider / Contractor)
                            </small>
                        </h4>
                    </div>
                </div> 
                
                <hr/>

                <h1 class="text-center">
                    Memorandum of Understanding
                </h1>           
                <ol class='list'>
                    <li>
                        Workplace First Aid Training LTD’s provider number 7199-3 (hereinafter called the “Provider”) and School name Board of Trustees (hereinafter called the “Board”) agrees to negotiate the supply of STAR/Gateway courses.
                    </li>
                    <li>
                        The Provider acknowledges that it is accredited or is in partnership with an accredited provider by the New Zealand Qualifications Authority (NZQA) for all courses provided. 
                    </li>
                    <li>
                        The Provider and Board agree that this Memorandum is a contract that will be in place until the end of <b class='fw-bold'>{ m.year }</b>.
                    </li>
                    <li>
                        The Provider and Board agree that the Provider’s academic policies contained within the Provider’s Policies and Procedures manual will apply to this programme.
                    </li>
                    <li>
                        The credits for the units achieved by students will be advised to the school and should be registered against the Providers NZQA code and the provider will take responsibility for moderation.
                    </li>
                    <li>
                        The Board will pay for all costs of reporting credits to NZQA. If the Provider is requested to report credits then it will be at a cost of $2.50 per credit to the Board.
                    </li>
                    <li>
                        Course cost is supplied by the provider via email to the Careers Advisor or STAR/Gateway Coordinator. Prices exclude gst.
                    </li>
                    <li>
                        The Board will pay invoices on the twentieth of the month of presentation of all invoices. 
                    </li>
                </ol>
                <p>
                    We acknowledge the First Aid Courses and associated Unit Standards outlined within the MOU letter of support, titled: “MOU Letter of Support: Workplace First Aid Training Courses” can be provided by Workplace First Aid Training.
                </p>
                <p>
                    To provide a quality service the Provider will:
                </p>
                <ul>
                    <li>
                        Provide quality resources.
                    </li>
                    <li>
                        Maintain a high standard of health and safety in premises external to school premises hired by the provider.
                    </li>
                    <li>
                        Advise student progress at key stages throughout the course.
                    </li>
                    <li>
                        Keep records of attendance and inform the school of attendance.
                    </li>
                </ul>
                <p>
                    The School will:
                </p>
                <ul>
                    <li>
                        Provide contact details of a person who supervises STAR/Gateway students.
                    </li>
                    <li>
                        Email student names, within 48 hours of the course to <a href="mailto:office@wpfirstaid.co.nz ">office@wpfirstaid.co.nz</a>
                    </li>
                    <li>
                        Provide a suitable parking space as close to the venue as possible in order to setup the equipment needed to facilitate the course. If such a space cannot be provided for any reason, please let us know at time of booking.
                    </li>
                    <li>
                        Forward results to NZQA.
                    </li>
                    <li>
                        Inform students that they will need to enter their details including date of birth, email, address as part of NZQA’s registration of unit standards.
                    </li>
                    <li>
                        Students’ email addresses will be required prior to the Comprehensive Workplace First Aid Course in order to complete the online learning.
                    </li>
                    <li>
                        Provide a suitable area for students to practice their skills, which will involve skills on the floor.
                    </li>
                    <li>
                        Inform the Provider at least two weeks in advance of cancellation of a course.
                    </li>
                    <li>
                        Advise students they will need to bring their packed lunch for the day. Timing of the course will be agreed upon to suit your needs.
                    </li>
                </ul>
                <hr/>

                {#if m.authorised === false}

                    <div class='alert alert-warning clearfix mb-3'>
                        <h4 class='float-start me-3'>
                            <span class='fas fa-info-circle'></span>
                        </h4>
                        You have yet to authorise this Contract
                    </div>

                    <div class='card'>
                        <div class='card-header'>
                            Authorise this Memorandum of Understanding
                        </div>
                        <div class='card-body'>

                            <form class='form' on:submit={authSubmitForm}>
                                <fieldset>
                                    <legend>
                                        Authorisation information
                                    </legend>                                                                    
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='name'>
                                            Your Name <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='text'
                                                class='form-control'
                                                bind:value={auth.auth_by_name}
                                                required
                                                placeholder="What is your name"
                                                class:is-invalid='{auth.auth_by_name == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='email'>
                                            Your Email <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='email'
                                                class='form-control'
                                                bind:value={auth.auth_by_email}
                                                required
                                                placeholder="What is your email address"
                                                class:is-invalid='{auth.auth_by_email == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='pos'>
                                            Your Position <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='text'
                                                class='form-control'
                                                bind:value={auth.auth_by_position}
                                                required
                                                placeholder="What is your position"
                                                class:is-invalid='{auth.auth_by_position == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='tc'>
                                            Terms & Conditions <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <div class='list-group'>
                                                <div
                                                    class='list-group-item js-button'
                                                    on:click={() => auth.tc = true}
                                                    on:keypress={() => auth.tc = true}
                                                    class:active='{auth.tc === true}'
                                                    role='button'
                                                    tabindex='0'
                                                >

                                                    {#if auth.tc === true}

                                                        <span class='fas fa-check-circle text-success me-2' in:fade></span>

                                                    {/if}

                                                    I agree to the <a href="/pdf/CONDITIONS_OF_SERVICE.pdf" target="_blank" class:text-white='{auth.tc === true}'><span class="fas fa-download"></span> Workplace First Aid Terms and Condtions</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='authorised'>
                                            Authorise <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <div class='list-group'>
                                                <div
                                                    class='list-group-item js-button'
                                                    on:click={() => auth.authorised = true}
                                                    on:keypress={() => auth.authorised = true}
                                                    class:active='{auth.authorised === true}'
                                                    role='button'
                                                    tabindex='0'
                                                >

                                                    {#if auth.authorised === true}

                                                        <span class='fas fa-check-circle text-success me-2' in:fade></span>

                                                    {/if}

                                                    I authorise this Agreement for Contract for Services with Workplace First Aid

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>
                                        Save Authorisation
                                    </legend>
                                    <div class='row mb-3'>
                                        <div class='col-sm-9 offset-sm-3'>
                                            <button type='submit' class='btn btn-outline-primary'>
                                                <span class='fas fa-save'></span> Save Authorisation
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>

                            </form>

                        </div>
                    </div>

                {/if}

            </div>
        </div>
    </section>

{/if}